import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { LocalService } from './storage/local.service';

@Injectable({
  providedIn: 'root',
})
export class SsoServiceService {
  private initialized = false;
  constructor(
    private readonly msalService: MsalService,
    private readonly localService: LocalService,
  ) {
    this.msalService.handleRedirectObservable().subscribe();
  }

  initialize() {
    if (!this.initialized) {
      this.msalService.initialize();
      this.initialized = true;
    }
  }

  login() {
    const account = this.msalService.instance.getActiveAccount();
    if (account) {
      this.getToken();
      this.msalService.instance.setActiveAccount(account);
      this.reloadPage();
    } else {
      return this.msalService
        .loginPopup({
          scopes: ['user.read'],
        })
        .subscribe({
          next: (response) => {
            this.msalService.instance.setActiveAccount(response['account']);
            this.getToken();
            this.reloadPage();
          },
          error: (error) => {
            console.error('Login failed:', error);
          },
      });
    }
    return null;
  }

  login2() {
    return this.msalService.loginRedirect().subscribe({
      next: () => {
        this.getToken();
        this.reloadPage();
      },
    });
  }

  logout() {
    this.msalService.logoutPopup({
      mainWindowRedirectUri: '/',
    });
  }

  get isLoggedIn() {
    return !!this.msalService.instance.getActiveAccount();
  }

  get username() {
    return this.msalService.instance.getActiveAccount()?.username;
  }

  get token() {
    return this.localService.getItem('token');
  }

  isTokenExpired() {
    const token = this.localService.getItem('token');
    if(token) {
      const payload = this.decodeJwt(token);
    
      // Obtenir le timestamp actuel en secondes (UTC)
      const currentTimeUTC = Math.floor(Date.now() / 1000);
          
      // Vérifier si le token est expiré
      const isExpired = !payload?.exp || currentTimeUTC >= (payload.exp);
      return isExpired;
    } else {
      return false;
    }
  }
    

  get getType() {
    return this.localService.getItem('type');
  }


  async getToken() {
    const account = this.msalService.instance.getActiveAccount();
    if (!account) {
      return '';
    }
    const token = this.msalService.instance.getActiveAccount()?.idToken || '';
    this.localService.setItem('token', token);
    return token;

  }

  async refreshToken() {
    const account = this.msalService.instance.getActiveAccount();
    if (!account) {
      return '';
    }
    console.log('Le token est expiré. Tentative de rafraîchissement...');

    try {
      const result = await this.msalService.instance.acquireTokenSilent({
        account,
        scopes: ['user.read'],
        forceRefresh: true
      });

      const refreshedIdToken = result.idToken;
      this.localService.setItem('token', refreshedIdToken);
      return refreshedIdToken;
    } catch (error) {
      console.error('Échec du rafraîchissement du token :', error);
      return '';
    }
  }

  private decodeJwt(token: string): any {
    try {
      const payload = token.split('.')[1];
      const decoded = atob(payload);
      return JSON.parse(decoded);
    } catch (error) {
      console.error('Erreur lors du décodage du token :', error);
      return null;
    }
  }

  reloadPage() {
    globalThis.location.reload();
  }
}
